import React from 'react';
import '../styles/ToggleSlider.css';

function ToggleSlider({ checked, onChange, label }) {
    return (
        <div className="toggle-setting">
            <span>{label}</span>
            <label className="switch">
                <input type="checkbox" checked={checked} onChange={onChange} />
                <span className="slider round"></span>
            </label>
        </div>
    );
}

export default ToggleSlider;
